<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'코칭 리포트'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle">
            <div style="position: relative;">
                <div style="position: absolute; z-index: 1;">
                    <img style="width: 100%; object-fit: cover;" :src="require('@/assets/img/coach_report_main.png')" alt="">
                </div>
                <div style="position: relative; z-index: 2; padding: 0 12px;">
                    <div style="display: flex; align-items: center; gap: 12px; padding-top: 24px;">
                        <div style="border-radius: 12px; width: 50px; height: 50px; overflow: hidden; border: 1px solid #d9d9d9;">
                            <img style="width: 100%; height: 100%;" :src="$resourcePath + coachInfo.image_path" alt="">
                        </div>
                        <div style="color: #fff;">
                            <div style="font-weight: 500;">{{ coachInfo.nic_name }}님,</div>
                            <div style="font-size: 12px; margin-top: 8px;">코칭을 시작해 볼까요?</div>
                        </div>
                    </div>
                    <div style="display: flex; gap: 10px; margin-top: 11px; margin-bottom: 24px;">
                        <div style="display: flex; gap: 5px; align-items:center; background: linear-gradient(90deg, #2376FF 0%, #00AFD6 100%); padding: 5px 7px; border-radius: 8px;">
                            <img style="width: 10px;" :src="require('@/assets/img/coach_report.png')" alt="">
                            <div style="color: #fff; font-weight: 500; font-size: 12px;">{{ coachInfo.coach_type === '감독' ? '감독' : '코치' }}</div>
                        </div>
                        <div v-if="coachInfo.licenses" style="display: flex; gap: 5px; align-items:center ; background: linear-gradient(90deg, #2376FF 0%, #00AFD6 100%); padding: 5px 7px; border-radius: 8px;">
                            <img style="width: 10px;" :src="require('@/assets/img/license_report.png')" alt="">
                            <div style="color: #fff; font-weight: 500; font-size: 12px;">{{ coachInfo.licenses }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex: 1; padding: 0 12px; font-weight: 500;">
                <div style="padding-top: 20px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px;">
                        <div style="font-weight: 700;">나의 경력</div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                            <img style="width: 12px;" :src="require('@/assets/img/modify_report.png')" alt="">
                            <div @click="showPersonalHistoryForm" style="color: var(--color-main); font-size: 12px;">수정</div>
                        </div>
                    </div>
                    <swiper style="border-radius: 12px; height: 100%; background: #E9FDFF; overflow: hidden; border: 1px solid #D6E7FE; " :options="swiperOption" role="tablist" ref="swiper">
                        <swiper-slide style=" padding: 14px; height: 100%; padding-bottom: 28px; position: relative;" role="tab">
                            <div style="position: relative;">
                                <div style="position: absolute;">
                                    <img style="width: 20px;" :src="require('@/assets/img/career_coach.png')" alt="">
                                </div>
                                <div style="padding-left: 26px; padding-top: 4px;">
                                    <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">지도자 경력 {{ coachHistory.career_period }}</div>
                                    <div style="margin-top: 5px;">
                                        <div :style="{marginTop: i === 0 ? '' : '5px'}" style="display: flex; gap: 5px; align-items: center;" v-for="each, i in coachPeriod" :key="i + 'coach_period'">
                                            <div style="font-size: 14px; line-height: 20px;">{{ each.team_name }}</div>
                                            <div style="font-size: 12px; color: #606060; line-height: 20px;">{{ each.period }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style=" padding: 14px; padding-bottom: 28px; position: relative;" role="tab">
                            <div style="position: relative;">
                                <div style="position: absolute;">
                                    <img style="width: 20px;" :src="require('@/assets/img/career_coach.png')" alt="">
                                </div>
                                <div style="padding-left: 26px; padding-top: 4px;">
                                    <div style="font-weight: 700; font-size: 14px; color: var(--color-main);">선수 경력 {{ playerPeriod[0].period }}</div>
                                    <div style="margin-top: 5px;">
                                        <div :style="{marginTop: i === 0 ? '' : '5px'}" style="display: flex; gap: 5px; align-items: center;" v-for="each, i in playerPeriod" :key="i + 'coach_period'">
                                            <div style="font-size: 14px; line-height: 20px;">{{ each.team_name }}</div>
                                            <!-- <div style="font-size: 12px; color: #606060; line-height: 20px;">{{ each.period }}</div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; background: #E9FDFF; bottom: 0px; height: 24px; text-align: center; z-index: 10; display:inline-block;"></div>
                    </swiper>
                </div>
                <div style="display: flex; margin-top: 15px; gap: 18px;">
                    <div @click="setCurTab(CUR_TAB.FEEDBACK_REQUEST)" :style="{ opacity: curTab === CUR_TAB.FEEDBACK_REQUEST ? '1' : '0.2' }" style="background: #FFEFDC; border: 1px solid #FFD19E; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background-color: var(--color-main);">
                            <img style="width: 10px;" :src="require('@/assets/img/reporting_search.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ feedbackRequestCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">피드백 요청</div>
                        </div>
                    </div>
                    <div @click="setCurTab(CUR_TAB.FEEDBACK_COMPLETE)" :style="{ opacity: curTab === CUR_TAB.FEEDBACK_COMPLETE ? '1' : '0.2' }" style="background: #CFF6D2; border: 1px solid #ACF0B1; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background: #2B8D32;">
                            <img style="width: 8px;" :src="require('@/assets/img/reporting_request.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ feedbackCompleteCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">피드백 완료</div>
                        </div>
                    </div>
                    <div @click="setCurTab(CUR_TAB.INTEREST_PLAYER)" :style="{ opacity: curTab === CUR_TAB.INTEREST_PLAYER ? '1' : '0.2' }" style="background: #DEECFF; border: 1px solid #B7D7FF; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background: #2366DB;">
                            <img style="width: 12px;" :src="require('@/assets/img/reporting_scout.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ interestPlayerCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">관심있는 선수</div>
                        </div>
                    </div>
                </div>
                <template v-if="curTab === CUR_TAB.FEEDBACK_REQUEST">
                    <div style="margin-top: 30px;">
                        <div v-for="each, i in feedbackList" :key="i + 'join_requests'" style="margin-bottom: 12px;">
                            <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px;">
                                <div>
                                    <ProfileImage :imagePath="each.from_member.image_path" style="width: 40px;"></ProfileImage>
                                </div>
                                <div style="width:100%;">
                                    <div style="font-weight: 700; font-size: 12px; margin-bottom: 4px;width:100%;position:relative;">
                                        {{ each.from_member.nic_name }}
                                        <span style="color: var(--color-main);">
                                            <DivisionPositionText :position="each.from_member.position"></DivisionPositionText>
                                        </span>
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color:#210F03; opacity: 0.7;">
                                        {{ each.from_member.place.name }}
                                        <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                                        {{ each.insert_date | agoDateStr }}
                                    </div>
                                </div>
                                <div style="flex:1;"></div>
                            </div>
                            <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px; padding-bottom: 0; padding-top: 8px;">
                                <CommonPost :hideProfile="true" :isChat="true" :soccerHows="each.soccerhow"></CommonPost>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="curTab === CUR_TAB.FEEDBACK_COMPLETE">
                    <div style="margin-top: 30px;">
                        <div v-for="each, i in feedbackList" :key="i + 'join_requests'" style="padding-bottom: 16px; margin-bottom: 16px; border-bottom: 2px solid #ebebeb;">
                            <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px; padding-bottom: 0; padding-top: 8px;">
                                <CommonPost :isChat="true" :soccerHows="each.soccerhow"></CommonPost>
                            </div>
                            <div style="margin-top: 16px; border-radius: 12px; padding: 12px; background-color: #f5f5f5;">
                                <div style="display: flex; gap: 8px;">
                                    <div style="width: 2px; border-radius: 22px; background-color: #ebebeb; margin-right: 4px;"></div>
                                    <div>
                                        <ProfileImage style="width: 40px;" :imagePath="myImage"></ProfileImage>
                                    </div>
                                    <div>
                                        <div style="font-weight: 700; font-size: 12px; line-height: 24px;">{{ $GlobalStore.loginInfo().nic_name }}</div>
                                        <div style="font-size: 15px; line-height: 24px;"><span style="color: #bbbbbb;">@{{ each.from_member.nic_name }} </span>{{ each.contents }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="curTab === CUR_TAB.INTEREST_PLAYER">
                    <div style="margin-top: 30px;">
                        <div v-for="each, i in interestPlayerList" :key="i + 'try_scout'" style="display: flex; align-items: center; margin-bottom: 24px;">
                            <div style="flex: 1;">
                                <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                            </div>
                            <div @click="sendMessage(each)" style="width: 78px; height: 40px; border-radius: 12px; line-height: 40px; text-align: center; background-color: #f5f5f5; color: var(--color-main); font-size: 14px; font-weight: 700;">메시지</div>
                        </div>
                    </div>
                </template>
            </div>
        </InfinityScroll>
        <BookmarkPopup :height="336" :isShowBookmarkPopup="isShowConfirmHistory" :closeBookmarkPopup="closeConfirmHistory">
            <div>
                <div @click="closeConfirmHistory" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 6px; margin-right: 60px;">
                    <img style="width: 249px;" :src="require('@/assets/img/confirm_history.png')" alt="">
                </div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">코치 경력 수정 요청이 전송되었습니다.<br>잠시만 기다려주세요.</div>
                <div style="margin-top: 8px; font-size: 12px; color: #606060; text-align: center;">보내주신 정보는 확인 후 수정되거나 반려될 수 있습니다</div>
                <div @click="closeConfirmHistory" style="width: 185px; margin: 0 auto; margin-top: 10px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; ">확인</div>
            </div>
        </BookmarkPopup>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonProfileNew from '@/components/common/CommonProfileNew';
import CommonPost from '@/components/soccerhowmain/CommonPost';
import DivisionPositionText from '@/components/common/DivisionPositionText'
import ProfileImage from '@/components/common/ProfileImage'
import { DIRECT_MESSAGE_TYPE, MEMBER_CAREER_HISTORY_STATE } from '@/Constants'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import { swiper, swiperSlide } from 'vue-awesome-swiper'

const CUR_TAB = {
    FEEDBACK_REQUEST: 'FEEDBACK_REQUEST',
    FEEDBACK_COMPLETE: 'FEEDBACK_COMPLETE',
    INTEREST_PLAYER: 'INTEREST_PLAYER'
}

export default {
    name: 'CoachingReport',
    components: { MercenaryHeader, swiper, swiperSlide, BookmarkPopup, CommonProfileNew, InfinityScroll, CommonPost, DivisionPositionText, ProfileImage },
    props: {

    },
    created() {
        this.getMyFeedbackList(false)
        this.getMyCoachingAnalyze()
    },
    data() {
        return {
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            MEMBER_CAREER_HISTORY_STATE: MEMBER_CAREER_HISTORY_STATE,
            CUR_TAB: CUR_TAB,
            curTab: CUR_TAB.FEEDBACK_REQUEST,
            isEnableNextPageHandle: true,
            page: 1,
            feedbackRequestCnt: 0,
            feedbackCompleteCnt: 0,
            interestPlayerCnt: 0,
            feedbackList: [],
            interestPlayerList: [],
            isShowConfirmHistory: false,
            coachHistory: {},
            coachPeriod: [],
            coachInfo: {},
            isExistModificationRequest: false,
            playerPeriod: []
        }
    },
    computed: {
        myImage() {
            return this.$GlobalStore.loginInfo().image_path
        }
    },
    methods: {
        closeConfirmHistory() {
            this.isShowConfirmHistory = false
        },
        showPersonalHistoryForm() {
            if (this.isExistModificationRequest) {
                this.isShowConfirmHistory = true
            } else {
                this.$GlobalStore.addModal('PersonalHistoryForm', { isModalBackTransparent : true, transitionName: 'top', mode: 'update', completeAction: this.completeAction })
            }
        },
        completeAction() {
            this.getMyCoachingAnalyze()
            setTimeout(() => {
                this.isShowConfirmHistory = true
            }, 600);
        },
        startScroll() {
            this.$nextTick(() => {
                const el = this.$refs.scrollWrapper;
                const h = el.offsetHeight - 95;
            
                const speed = 20;
                const duration = h / speed; // 내려가는 데 걸리는 시간(s)
            
                function animate() {
                
                    // 1) 내려가기
                    el.style.transition = `transform ${duration}s linear`;
                    el.style.transform = `translateY(-${h}px)`;
                
                    // 2) 내려간 뒤 1초 대기 후 → 위로 순간 복귀
                    setTimeout(() => {
                        el.style.transition = '';
                        el.style.transform = 'translateY(0)';
                    }, duration * 1000 + 1000);  // 내려가는 시간 + 1초
                
                    // 3) 위로 돌아온 뒤 1초 대기 후 → 다음 애니메이션 실행
                    setTimeout(() => {
                        animate();
                    }, duration * 1000 + 1000 + 1000);
                }
            
                // 처음 시작도 1초 대기 후 진행
                setTimeout(() => {
                    animate();
                }, 1000);
            });
        },
        sendMessage(memberInfo) {
            this.$Util.showDirectMessageSenderForm({ memberInfo: memberInfo, isDirectUser: true });
        },
        refresh() {
            if (this.curTab !== CUR_TAB.INTEREST_PLAYER) {
                this.page = 1
                this.feedbackList = []
                if (this.curTab === CUR_TAB.FEEDBACK_REQUEST) {
                    this.getMyFeedbackList(false)
                } else {
                    this.getMyFeedbackList(true)
                } 
            } else {
                this.interestPlayerList = []
                this.getMyInterestPlayers()
            }
            this.getMyCoachingAnalyze()
        },
        handleNextPage() {
            if (this.curTab !== CUR_TAB.INTEREST_PLAYER) {
                this.page++
                if (this.curTab === CUR_TAB.FEEDBACK_REQUEST) {
                    this.getMyFeedbackList(false)
                } else if (this.curTab === CUR_TAB.FEEDBACK_COMPLETE) {
                    this.getMyFeedbackList(true)
                }
            }
        },
        setCurTab(tab) {
            if (this.curTab === tab) {
                return
            }
            this.page = 1
            this.curTab = tab

            if (this.curTab === CUR_TAB.FEEDBACK_REQUEST) {
                this.feedbackList = []
                this.getMyFeedbackList(false)
            } else if (this.curTab === CUR_TAB.FEEDBACK_COMPLETE) {
                this.feedbackList = []
                this.getMyFeedbackList(true)
            } else if (this.curTab === CUR_TAB.INTEREST_PLAYER) {
                this.interestPlayerList = []
                this.getMyInterestPlayers()
            }
        },
        async getMyFeedbackList(isNeedStatus) {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.direct_message_types = [DIRECT_MESSAGE_TYPE.FEEDBACK]
            if (isNeedStatus) {
                parameters.status = 1
            }
            const res = await this.$Axios.get('/api/direct_message/mine', { params: parameters })
            
            const feedbackList = res.data.direct_message
            if (feedbackList.length > 0) {
                this.isEnableNextPageHandle = true
                feedbackList.forEach(item => {
                    item.soccerhow.nic_name = item.from_member.nic_name
                    item.soccerhow.place_name = item.from_member.place.name
                    item.soccerhow.position = item.from_member.position
                    item.soccerhow.image_path = item.from_member.image_path
                })
                this.feedbackList = [...this.feedbackList, ...feedbackList]
            }
        },
        async getMyInterestPlayers() {
            const res = await this.$Axios.get('/api/coach/coaching/interest_players')
            const interestPlayers = res.data.interest_players

            this.interestPlayerList = interestPlayers
        },
        async getMyCoachingAnalyze() {
            const res = await this.$Axios.get('/api/coach/coaching/analyze')
            const feedbackRequestCnt = res.data.feedback_request_cnt
            const feedbackCompleteCnt = res.data.feedback_complete_cnt
            const interestPlayerCnt = res.data.interest_player_cnt
            const coach_history = res.data.coach_history
            const coach_info = res.data.coach_info

            this.coachInfo = coach_info
            this.coachHistory = coach_history
            this.feedbackRequestCnt = feedbackRequestCnt
            this.feedbackCompleteCnt = feedbackCompleteCnt
            this.interestPlayerCnt = interestPlayerCnt
            this.isExistModificationRequest = res.data.is_exist_modification_request

            this.coachPeriod = JSON.parse(this.coachHistory.coach_period)
            this.playerPeriod = JSON.parse(this.coachHistory.player_period)
            // this.startScroll()
        }
    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: #82BEFF;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #1153FB;
    width: 26px;
    height: 6px;
    border-radius: 8px;
}

</style>